import StarRatings from "component/design-system/StarRatings";
import PAImage from "component/design-system/images/PAImage";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { RootState } from "interfaces/generics.type";
import { useTranslation } from "next-i18next";
import { useSelector } from "react-redux";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import { numberFormat } from "util/helper/numberFormat";
import styles from "./customer-review-v2.module.scss";

function GoogleRatingSummary() {
  const { t } = useTranslation("home");
  const { averageRating, totalReviewCount } = useSelector((store: RootState) => store.authenticationState);

  return (
    <div className={styles.google_summary_card}>
      <div className={styles.google_left}>
        <div>
          <PAImage
            width={40}
            height={40}
            alt="Google"
            src={getRelativeImagePath("/cms/pubicImages/images/google-logo-v2.webp")}
          />
          <PAText color="light-grey" fontSize={FONT_SIZE[0]}>Google</PAText>
        </div>
        <div className={styles.google_rating_info}>
          <PAText component="span" fontSize={FONT_SIZE[5]} bold>{averageRating}</PAText>
          <PAText component="span" fontSize={FONT_SIZE[6]} color="medium-grey">{t("out of 5")}</PAText>
          <div className={styles.google_stars}>
            <StarRatings rating={Number(averageRating) || 4.6} />
          </div>
        </div>
      </div>
      <div className={styles.google_right}>
        <PAText component="span" fontSize={FONT_SIZE[5]} bold>
          {`${numberFormat(totalReviewCount)}+`}
        </PAText>
        <PAText component="span" fontSize={FONT_SIZE[6]} color="light-grey">{t("Reviews")}</PAText>
      </div>
    </div>
  );
}

export default GoogleRatingSummary;
